export default class APIServiceError {
  public response: any;

  constructor(response: any) {
    this.response = response;
  }
}
